import React, { useContext, useState } from 'react';
import { CompanyRelationService, IntegrationSettingsInput } from '../../../../../../types/integration_settings';
import { SuperUserContext } from '../../../../../../context/SuperUserContext';
import { SuperUserRole } from '../../../../../../types/superUser';
import TeamLeaderLogo from '../../../../../../assets/img/TeamLeaderLogo.png';
import BusinessCentralLogo from '../../../../../../assets/img/BusinessCentralLogo.png';
import SAPLogo from '../../../../../../assets/img/SAPLogo.png';
import MicrosoftLogo from '../../../../../../assets/img/MicrosoftLogo.svg';
import { Divider } from '../../../../../components/Divider';
import { Button, CancelButton } from '../../../../../components/Button';
import { translate } from '../../../../../../types/translation/Translator';
import { TranslationKey } from '../../../../../../types/translation/TranslationKey';
import { IntegrationModalState } from '../IntegrationModal';
import { ActionModalBody, ActionModalFooter } from '../../../../../components/Modal/templates/ActionModal';

interface IntegrationModalTypePaneProps {
  input: IntegrationSettingsInput;
  setInput: (input: IntegrationSettingsInput) => void;

  setType: (type: IntegrationModalState) => void;

  handleCancel: () => void;
}

export default function IntegrationModalTypePane({
  input,
  setInput,
  setType,
  handleCancel,
}: IntegrationModalTypePaneProps) {
  const { superUser } = useContext(SuperUserContext);

  const [pane, setPane] = useState<IntegrationModalState>(IntegrationModalState.teamleader);

  const integrations = [
    {
      type: CompanyRelationService.teamleader,
      icon: TeamLeaderLogo,
      pane: IntegrationModalState.teamleader,
    },
    {
      type: CompanyRelationService.microsoft,
      icon: MicrosoftLogo,
      pane: IntegrationModalState.microsoft,
    },
    {
      type: CompanyRelationService.sap,
      icon: SAPLogo,
      pane: IntegrationModalState.teamleader,
    },
    {
      type: CompanyRelationService.businessCentral,
      icon: BusinessCentralLogo,
      pane: IntegrationModalState.teamleader,
    },
  ].filter(
    integration =>
      integration.type === CompanyRelationService.teamleader ||
      integration.type === CompanyRelationService.microsoft ||
      superUser?.role === SuperUserRole.administrator,
  );

  return (
    <>
      <ActionModalBody>
        <div className='flex gap-2'>
          {integrations.map(integration => (
            <div
              className='h-[150px] w-[250px] cursor-pointer select-none border px-2'
              style={{ borderColor: input.type === integration.type ? '#3B82F6' : '#D1D5DB' }}
              key={integration.type}
              onClick={() => {
                setInput(input.withType(integration.type));
                setType(integration.pane);
              }}
            >
              <img src={integration.icon} />
            </div>
          ))}
        </div>
      </ActionModalBody>
      <Divider />
      <ActionModalFooter>
        <div className='flex justify-end gap-2'>
          <CancelButton onClick={handleCancel} />
          <Button text={translate({ key: TranslationKey.next })} onClick={() => setType(pane)} />
        </div>
      </ActionModalFooter>
    </>
  );
}
